import _ from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { Button, Icon, List } from 'semantic-ui-react'
import { BaseSettingsContext } from '../../../cnr/contexts/BaseSettingsContext'
import { creatingHelpers } from '../../../common/creating'
import { uniqueKey } from '../../../common/keys'
import UiSaveButtons from '../../../components/buttons/UiSaveButtons'
import AppForm from '../../../components/forms/appForms/AppForm'
import { appFormTypes } from '../../../enums/appFormTypes'
import { gEnums } from '../../../enums/globalEnums'
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper'
import { vsComponentTypes } from '../../enums/vsComponentTypes'

const SettingsConsole = (props) => {

  const { vsComponentType } = props

  const baseSettingsContext = useContext(BaseSettingsContext)
  const { baseSettings_state, baseSettings_handlers } = baseSettingsContext ?? {}
  const { baseSettings } = baseSettings_state ?? {}
  const { adjustedPermissions } = baseSettings ?? {}
  const { global, page, group, pageItem, prop, propSection } = adjustedPermissions ?? {}

  const [consoleKey, setConsoleKey] = useState()
  const [consoleGroup, setConsoleGroup] = useState()
  const [consoleGrouped, setConsoleGrouped] = useState()
  const [updating, setUpdating] = useState()
  const [activeConsoleKey, setActiveConsoleKey] = useState()
  const [currentFormData, setCurrentFormData] = useState()

  useEffect(() => {
    let _consoleKey;
    let _consoleKeys = [];
    let _consoleGroup = {};
    switch (vsComponentType) {
      case vsComponentTypes.groupSettings:
        _consoleKeys = Object.keys(gEnums.settingsMenuGroupTypes).sort()
        _consoleGroup = group
        _consoleKey = 'group'
        break;
      case vsComponentTypes.globalSettings:
        _consoleKeys = Object.keys(global).sort()
        _consoleGroup = global
        _consoleKey = 'global'
        break;
      case vsComponentTypes.pageSettings:
        _consoleKeys = Object.keys(page).sort()
        _consoleGroup = page
        _consoleKey = 'page'
        break;
      case vsComponentTypes.pageItemSettings:
        _consoleKeys = Object.keys(pageItem).sort()
        _consoleGroup = pageItem
        _consoleKey = 'pageItem'
        break;
      case vsComponentTypes.propSettings:
        _consoleKeys = Object.keys(prop).sort()
        _consoleGroup = prop
        _consoleKey = 'prop'
        break;
      case vsComponentTypes.propSectionSettings:
        _consoleKeys = Object.keys(propSection).sort()
        _consoleGroup = propSection
        _consoleKey = 'propSection'
        break;
      case vsComponentTypes.dataModes:
        _consoleKeys = Object.keys(propSection).sort()
        _consoleGroup = propSection
        _consoleKey = 'propSection'
        break;
      default:
      // nothing
    }

    creatingHelpers.createKeys(_consoleGroup)
    const _consoleGrouped = _.groupBy(_consoleGroup, 'settingsAuthLevel')
    setConsoleKey(_consoleKey)
    setConsoleGroup(_consoleGroup)
    setConsoleGrouped(_consoleGrouped)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFormDataChange_local = (formData) => {
    const _formData = { ...formData }
    const { appAreaTypes, pageAreaTypes } = _formData ?? {}
    if (appAreaTypes || pageAreaTypes) {
      _formData.componentAreas = {}
      if (appAreaTypes) { _formData.componentAreas.appAreaTypes = appAreaTypes }
      if (pageAreaTypes) { _formData.componentAreas.pageAreaTypes = pageAreaTypes }
    }
    delete _formData.appAreaTypes
    delete _formData.pageAreaTypes
    setCurrentFormData(_formData)
  }

  const callback = () => setUpdating(false)

  const handleSaveSettings = () => {
    setUpdating(true)
    baseSettings_handlers.handleUpdateAdjustedPermissions(consoleKey, consoleGroup, callback)
  }

  const handleAmmendSetting = () => {
    const _consoleGroup = { ...consoleGroup }
    _consoleGroup[activeConsoleKey] = currentFormData
    setConsoleGroup(_consoleGroup)
    setActiveConsoleKey()
  }

  const handleItemClick = (key) => {
    if (activeConsoleKey === key) {
      setActiveConsoleKey()
    } else {
      setActiveConsoleKey(key)
    }
  }

  const appForm = () => {
    const activeItem_data = consoleGroup ? consoleGroup[activeConsoleKey] : {}
    console.log('activeItem_data', activeItem_data)
    let _data;
    const { componentAreas } = activeItem_data ?? {}
    if (componentAreas) {
      _data = { ...activeItem_data, ...componentAreas }
      delete _data.componentAreas
    } else {
      _data = activeItem_data
    }
    return <AppForm
      _formAttributes={{ inverted: true }}
      appFormType={appFormTypes[vsComponentType]}
      initData={_data}
      data_parent={_data}
      handleUpdateParentData={handleFormDataChange_local}
      key={uniqueKey(vsComponentType)}
      ignoreItemStatus={true}
    />
  }

  const arrayString = (arr) => {
    let s = ''
    if (_.isArray(arr)) {
      arr.forEach((a, index) => {
        s += _.startCase(a)
        if (index < arr.length - 1) {
          s += ', '
        }
      })
    }
    return s
  }

  const inString = (settingsMenuGroupType) => {
    switch (vsComponentType) {
      case vsComponentTypes.groupSettings:
        break;
      case vsComponentTypes.globalSettings:
      case vsComponentTypes.pageSettings:
        let icon;
        let iconColor;
        switch (settingsMenuGroupType) {
          case 'none':
            icon = 'hide'
            iconColor = 'grey'
            break;
          default:
            icon = 'object group'
            iconColor = 'olive'
        }
        return <div style={{ fontSize: '.8rem', color: 'lightgrey' }}><Icon name={icon} color={iconColor}></Icon>{_.startCase(settingsMenuGroupType)}</div>
      default:
      // nohting
    }
  }

  const btni = (name, title) => <Button icon title={title}>
    <Icon name={name} />
  </Button>

  const bg = (types, color) => {
    const itypes = ['all', 'home', 'clients', 'client', 'event', 'global', 'page']
    const btns = []
    if (types) {
      itypes.forEach(it => {
        if (types.includes(it)) {
          switch (it) {
            case 'home':
              btns.push(btni('home', _.startCase(it)))
              break;
            case 'client':
              btns.push(btni('user', _.startCase(it)))
              break;
            case 'clients':
              btns.push(btni('users', _.startCase(it)))
              break;
            case 'event':
              btns.push(btni('calendar check outline', _.startCase(it)))
              break;
            case 'global':
              btns.push(btni('globe', _.startCase(it)))
              break;
            case 'page':
              btns.push(btni('file outline', _.startCase(it)))
              break;
            case 'all':
              btns.push(btni('check circle outline', _.startCase(it)))
              break;
            default:
              btns.push(btni('check circle outline'))
              break;
          }
        }
      })
    } else {
      btns.push(btni('circle outline', 'Not Set'))
    }
    return <Button.Group size='mini' color={color}>
      {btns}
    </Button.Group>
  }

  const listItem = (consoleKey, item) => {

    const consoleItem = item ? item : consoleGroup[consoleKey]
    const { appAs, appAsNull, caption, icon, settingsAuthLevel, settingsMenuGroupType, componentAreas, restrict } = consoleItem ?? {}

    const { appAreaTypes, pageAreaTypes } = componentAreas ?? {}
    let _caption = caption ? _.startCase(consoleKey) + ' (' + caption + ')' : _.startCase(consoleKey)

    const settingsIcon = {
      icon: icon ? icon : 'cog',
      color: 'grey',
    }

    const adminIcon = {
      icon: 'user outline',
      color: 'blue',
    }

    const plc = _.find(gEnums.authLevels, { value: settingsAuthLevel })
    if (plc && plc.color) { adminIcon.color = plc.color }
    if (plc && plc.icon) { adminIcon.icon = plc.icon }

    if (appAs) { _caption = _caption + ' *' }
    if (appAsNull) { _caption = _caption + ' **' }
    if (restrict) {
      settingsIcon.icon = 'ban'
      settingsIcon.color = 'red'
    }

    return <List.Item>
      <List.Content>
        <List.Content floated='right' style={{ fontSize: '.8rem' }} >
          {bg(pageAreaTypes, 'teal')}
        </List.Content>
        <List.Content floated='right' style={{ fontSize: '.8rem' }} >
          {bg(appAreaTypes, 'blue')}
        </List.Content>
        <List.Header onClick={() => handleItemClick(consoleKey)}><Icon name={settingsIcon.icon} color={settingsIcon.color} /><Icon name={adminIcon.icon} color={adminIcon.color} />{_caption}</List.Header>
        {inString(settingsMenuGroupType)}
      </List.Content>
    </List.Item>
  }

  const listItems_grouped = () => {
    let items = []
    Object.keys(consoleGrouped).forEach(cgKey => {
      const consoleGroup = consoleGrouped[cgKey]
      const iis = _.sortBy(consoleGroup, 'key').map(item => (listItem(item.key)))
      items.push(iis)
    })

    return items
  }

  const content_grouped = () => <List inverted relaxed divided className={'settings-console-list'}>{listItems_grouped()}</List>

  const wrapper = () => <Wrapper
    content={consoleGrouped ? content_grouped() : <div></div>}
    footer={<UiSaveButtons save={{ oc: handleSaveSettings, caption: 'Update Settings Database' }} />}
    wrapperType={wrapperTypes.padded}
    updating={updating}
  ></Wrapper >

  const wrapper_selected = () => <Wrapper
    content={appForm()}
    footer={<UiSaveButtons save={{ oc: handleAmmendSetting, caption: 'Update Selected', color: 'blue', icon: 'check' }} />}
    wrapperType={wrapperTypes.paddedFooter}
    updating={updating}
    handleBack={handleItemClick}
    handleBackCaption={_.startCase(activeConsoleKey)}
  ></Wrapper >

  return activeConsoleKey ? wrapper_selected() : wrapper()

}

export default SettingsConsole